import type React from "react";

export default function getDisplayName(
  WrappedComponent: React.ComponentType<any> | React.FC<any>,
): string {
  return WrappedComponent.displayName || WrappedComponent.name;
}
